export function isContestOngoing(lang: string) {
  return false
}

export function isFamilyContestOngoing() {
  const now = new Date()
  const start = new Date('2026-05-01T00:00:00')
  const end = new Date('2026-06-30T23:59:59')
  return now >= start && now <= end
}
